import { Box, Button, Typography } from "@mui/material";
import styles from "../../pages/academy/academy.module.css";
import Girl from "../../assets/girl.png";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import {fontType} from "../../constants/font";
import InfoBanner from "../academy/InfoBanner";

const IntroCourses = ({ windowWidth }) => {
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const [ref, inView] = useInView({
    triggerOnce: true, // Only trigger the animation once when scrolled into view
  });

  return (
    <Box
      sx={{
        backgroundColor: "#7b7cd5",
        display: "flex",
        justifyContent: "center",
        position: "relative",
        overflow: "hidden",
        paddingTop: "85px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          position: "relative",
          overflow: "hidden",
          maxWidth: "1440px",
          width: "100%",
        }}
      >
        <img
          className={styles.element}
          style={{
            position: "absolute",
            zIndex: 2,
            bottom: 110,
          }}
          src={require("../../assets/elements_c.png")}
          alt="intro_floating_icons"
        />
          {windowWidth >= 600 && <InfoBanner windowWidth={windowWidth} />}
        <Box
          sx={{
            backgroundImage: `url(${Girl})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            maxWidth: "1440px",
            width: "100%",
            display: "flex",
            alignItems: "center",
            position: "relative",
            justifyContent: "center",
            paddingBottom: {xs: '392px', sm: '292px'},
          }}
        >
          <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
            transition={{ duration: 0.7 }}
          >
            <Box
              sx={{
                position: "relative",
                zIndex: 3,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  marginBottom: "19px",
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <Typography
                  sx={{
                    // fontSize: { md: 55, xs: 35 },
                    fontSize: 55,
                    fontFamily: fontType.regular,
                    color: "#1b144a",
                    lineHeight: "65px",
                    // lineHeight: { md: "65px", xs: 1.2 },
                    marginBottom: "14px",
                    maxWidth: "350px",
                    textAlign: "center",
                  }}
                >
                  HĽ<span style={{ color: "white" }}>AA</span>DÁŠ <span style={{ color: "white" }}>S</span>I ŠKOLENIE?
                </Typography>
                <Typography
                  sx={{
                    fontSize: 28,
                    fontFamily: fontType.regular,
                    color: "white",
                    lineHeight: "38px",
                  }}
                >
                  Nasmeruj svoju kariéru
                </Typography>
              </Box>
              <Box
                sx={{
                  maxWidth: "365px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  onClick={() => scrollToSection("course-list")}
                  sx={{
                    borderRadius: "28px",
                    border: "2px solid",
                    borderColor: "#3fcaea",
                    backgroundColor: "transparent",
                    fontFamily: fontType.semiBold,
                    fontSize: 16,
                    cursor: "pointer",
                    color: "white",
                    height: "41px",
                    width: "165px",
                    textTransform: "initial",
                    "&:hover": {
                      borderColor: "white",
                    },
                  }}
                >
                    Vybrať školenie
                </Button>
              </Box>
            </Box>
          </motion.div>
        </Box>
      </Box>
    </Box>
  );
};

export default IntroCourses;
